import { getCssVar } from '@/utils/getCssVar'

const getCssVarsForAntDesignToken = () => {
	const baseFontSize = +(getCssVar('base-font-size')?.replace('px', '') ?? 16)
	const baseBorderRadius = +(getCssVar('base-border-radius')?.replace('px', '') ?? 4)

	return {
		primaryColor: getCssVar('primary-color'),
		secondaryColor: getCssVar('secondary-color'),
		infoColor: getCssVar('info-color'),
		successColor: getCssVar('success-color'),
		warnColor: getCssVar('warning-color'),
		dangerColor: getCssVar('danger-color'),
		textColor: getCssVar('main-text-color'),
		blueColor: getCssVar('blue-color'),
		bodyBgColor: getCssVar('body-bg-color'),
		mainFontFamily: getCssVar('main-font'),
		baseFontSize,
		baseBorderRadius,
	}
}

export const getAntDThemeToken = () => {
	const cssVars = getCssVarsForAntDesignToken()

	return {
		borderRadius: cssVars.baseBorderRadius,
		borderRadiusLG: cssVars.baseBorderRadius * 2,
		colorBgBase: '#fff',
		colorError: cssVars.dangerColor,
		colorInfo: cssVars.infoColor,
		colorPrimary: cssVars.primaryColor,
		colorSuccess: cssVars.successColor,
		colorTextBase: cssVars.textColor,
		colorWarning: cssVars.warnColor,
		colorLink: cssVars.blueColor,
		fontFamily: cssVars.mainFontFamily,
		fontSize: cssVars.baseFontSize,
		/* This token applies specifically to the background of buttons with type="primary" on hover. */
		colorPrimaryHover: getCssVar('light-gray-color'),
		/* This token applies specifically to the text color of buttons with type="primary" on hover. */
		colorTextLightSolid: getCssVar('main-text-color'),
		controlItemBgActive: `${cssVars.secondaryColor}40`,
		controlHeightLG: 48,
		lineWidth: 2,
		InputNumber: {
			paddingInlineLG: 20,
		},
	}
}
